// react, router
import React from "react"
import { browserHistory, Router, Route, IndexRedirect } from "react-router"
// app
import Account from "containers/Account"
import Application from "containers/Application"
import auth from "containers/Authenticate"
import ForgotPassword from "containers/ForgotPassword"
import Login from "containers/Login"
import Me from "containers/Profile/Me"
import NewProfile from "containers/Profile/New"
import Profile from "containers/Profile"
import Profiles from "containers/Profiles"
import SearchForm from "containers/Search/Form"
import SearchResult from "containers/Search/Result"
import SignUp from "containers/SignUp"


export default() => (
    <Router history={ browserHistory }>
        <Route path="/" component={ Application }>
            <IndexRedirect to="profile" />

            <Route path="login" component={ Login } />
            <Route path="success" component={ Login } />
            <Route path="signup" component={ SignUp } />
            <Route path="forgot" component={ ForgotPassword } />

            <Route path="profiles" component={ auth(Profiles, true) } />
            <Route path="profile/new" component={ auth(NewProfile, true) } />
            <Route path="profiles/:personid" component={ auth(Profile, true) } />
            
            <Route path="profile" component={ auth(Me) } />

            <Route path="search" component={ auth(SearchForm, true) } />
            <Route path="search/result" component={ auth(SearchResult, true) } />

            <Route path="account" component={ auth(Account) } />
        </Route>
    </Router>
)



/** WEBPACK FOOTER **
 ** ./src/router.js
 **/